import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export interface Site {
  id: string;
  name: string;
}

export function useTeamSites() {
  return useQuery<Site[]>({
    queryKey: [APIKey.TEAM_SITES],
    queryFn: () => baseFetcher(apiRoutes.teamSites()),
  });
}
